import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as adminlte from 'admin-lte/dist/js/adminlte.js';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor(private router: Router) { }

  logoutNavegation() {
    localStorage.removeItem('userToken');
    this.router.navigate(['/login']);
  }

  ngOnInit() {
    // adminlte.PushMenu('toggle');
  }

}
